'use es6';

import { createSelector } from 'reselect';
import { Set as ImmutableSet } from 'immutable';
import { parse } from 'hub-http/helpers/params';
import { FILTER_TYPES } from '../constants/TopFilterConstants';
export const getParsedSearch = (_state, ownProps) => ownProps.location.search ? parse(ownProps.location.search.slice(1)) : {};
export const getSearch = createSelector(getParsedSearch, parsedSearch => parsedSearch[FILTER_TYPES.SEARCH] || '');
export const getConfirmSwap = createSelector(getParsedSearch, parsedSearch => parsedSearch.confirmSwap === 'true');
export const getConfirmationGuid = createSelector(getParsedSearch, parsedSearch => parsedSearch.confirmationGuid);
const getSelectedFilterByName = queryFilters => {
  let selected = ImmutableSet();

  // queryFilters can here be undefined (if no filters are in the url), a string (if one) or an array (if many)
  if (queryFilters && queryFilters.length > 1) {
    selected = ImmutableSet(typeof queryFilters === 'string' ? [queryFilters] : queryFilters);
  }
  return selected;
};
export const getSelectedCategoryFiltersFromRoute = createSelector(getParsedSearch, parsedSearch => getSelectedFilterByName(parsedSearch.cat));
export const getSelectedLanguageFiltersFromRoute = createSelector(getParsedSearch, parsedSearch => getSelectedFilterByName(parsedSearch[FILTER_TYPES.LANGUAGE]));
export const getSelectedToolFiltersFromRoute = createSelector(getParsedSearch, parsedSearch => getSelectedFilterByName(parsedSearch.tools));
export const getPageFromPathname = (_, ownProps) => {
  let page;
  try {
    page = parseInt(ownProps.match.params.page, 10);
  } catch (e) {
    if (!(e instanceof TypeError)) {
      throw e;
    }
  }
  // Return a positive integer, or null
  return page && page > 0 ? page : null;
};